export default "<p>advertisement works!</p>\n"